// $(document).ready(function(){
//     $('.sciacca-slider__inner').slick({

//       slidesToShow: 3,
//       infinite: false,
//       prevArrow:'<button type="button" class="slick-prev icon icon-angle-left"></button>',
//       nextArrow:'<button type="button" class="slick-next icon icon-angle-right"></button>',

//       responsive: [
//         {
//           breakpoint: 992,
//           settings: {
//             slidesToShow: 2
//           }
//         },
//         {
//           breakpoint: 768,
//           settings: {
//             slidesToShow: 2
//           }
//         },
//         {
//           breakpoint: 576,
//           settings: {
//             slidesToShow: 1
//           }
//         },
//       ]
//     });
// });




//Подвижное меню
$(document).ready(function(){
    $(window).scroll(function() {
        var winHeight  = $(window).height();
        // if ($(window).scrollTop() > winHeight) {
        //     $(".btn--cta").removeClass("hidden");
        // } else {
        //     $(".btn--cta").addClass("hidden");
        // }
        if ($(window).scrollTop() > 100){
           $(".navbar").addClass("navbar--fixed"); 
        } else {
           $(".navbar").removeClass("navbar--fixed");  
        }
        if ($(window).scrollTop() > 200) {
            $(".btn--cta").addClass("cta-fixed");
            // $(".navbar").addClass("navbar--fixed");
        } else {
            $(".btn--cta").removeClass("cta-fixed");
            // $(".navbar").removeClass("navbar--fixed");
        }
    });
});
//End 



//Smooth Scroll on Page
$(document).ready(function(){
    $(".btn-bottom").on("click", function (event) {
        //отменяем стандартную обработку нажатия по ссылке
        event.preventDefault();

        //забираем идентификатор бока с атрибута href
        var id  = $(this).attr('href'),

        //узнаем высоту от начала страницы до блока на который ссылается якорь
            top = $(id).offset().top;
        
        //анимируем переход на расстояние - top за 1500 мс
        $('body,html').animate({scrollTop: top}, 500);
    });
});
//End Smooth Scroll



//- Menu close/open
$(document).ready(function () {
    $(".menu-button").click(function () {
        $(this).toggleClass("menu-button--to-open"),
        $(this).toggleClass("menu-button--to-close"),
        $(this).hasClass("menu-button--to-close") ? $(".menu").addClass("menu--visible") : $(".menu").removeClass("menu--visible")
    })
});

//- При изменении ширины окна браузера на ширине 1200px сворачивается меню, если оно было развернуто.
//- срабатывает событие клика на кнопку, чтобы и меню, и кнопка приняли необходимый вид для широких экранов
$(window).resize(function(){
    if($(window).width()>=1200){
        if($('.menu').hasClass('menu--visible')){
            $('.menu-button').click();
        }
    }
});



$(document).ready(function() {
    $('.btn--cta').click( function(event){
        event.preventDefault();
        $("#h-contactForm")[0].reset();
        $('#overlay').fadeIn(400, // анимируем показ обложки
            function(){ // далее показываем мод. окно
                $('#modal_form') 
                    .css('display', 'block')
                    .animate({opacity: 1}, 200);
        });
    });
 
    // закрытие модального окна
    $('#modal_close, #overlay').click( function(){
        $("#h-msgSubmit").removeClass().addClass("error-hidden").empty();
        $("#h-contactForm .form-group").removeClass("has-error");
        $('#modal_form')
            .animate({opacity: 0}, 200,  // уменьшаем прозрачность
                function(){ // пoсле aнимaции
                    $(this).css('display', 'none'); // скрываем окно
                    $('#overlay').fadeOut(400); // скрывaем пoдлoжку
                }
            );
    });
});


$("#h-contactForm").validator().on("submit", function (event) {
    if (event.isDefaultPrevented()) {
        // handle the invalid form...
        formError();
        hsubmitMSG(false, "Пожалуйста, проверьте правильность заполнения формы");
    } else {
        // everything looks good!
        event.preventDefault();
        hsubmitForm();
    }
});


function hsubmitForm(){
    // Initiate Variables With Form Content
    var name = $("#h-name").val();
    var email = $("#h-email").val();
    var excursion = $("#h-excurs").val();
    var guide = $("#h-guide").val();
    var message = $("#h-message").val();

    $.ajax({
        type: "POST",
        url: "php/form-process.php",
        data: "name=" + name + "&email=" + email + "&excurs" + excursion + "&guide" + guide + "&message=" + message,
        success : function(text){
            if (text == "success"){
                hformSuccess();
            } else {
                hsubmitMSG(false, text);
            }
        }
    });
}

function hformSuccess(){
    $("#h-contactForm")[0].reset();
        hsubmitMSG(true, "Ваше сообщение отправлено!");
}


function hsubmitMSG(valid, msg){
    if(valid){
        var msgClasses = "text-success";
    } else {
        var msgClasses = "text-danger";
    }
    $("#h-msgSubmit").removeClass().addClass(msgClasses).text(msg);
}





// Форма обратной связи

$("#contactForm").validator().on("submit", function (event) {
    if (event.isDefaultPrevented()) {
        // handle the invalid form...
        formError();
        submitMSG(false, "Пожалуйста, проверьте правильность заполнения формы");
    } else {
        // everything looks good!
        event.preventDefault();
        submitForm();
    }
});


function submitForm(){
    var formData = $("#contactForm").serialize();

    if($("#contactForm").hasClass("form-reviews")){
        var phpUrl="php/inviaRecensione.php";
    } else {
       var phpUrl="php/form-process.php"; 
    }

    $.ajax({
        type: "POST",
        url: phpUrl,
        data: formData,

        success : function(text){
            if (text == "success"){
                formSuccess();
            } else {
                submitMSG(false, text);
            }
        }
    });
}

function formSuccess(){
    $("#contactForm")[0].reset();
    if($("#contactForm").hasClass("form-reviews")){
         submitMSG(true, "Спасибо за ваш отзыв! После проверки администратором он будет опубликован!");
    } else {
        submitMSG(true, "Ваше сообщение отправлено!");
    }
}


function submitMSG(valid, msg){
    if(valid){
        var msgClasses = "text-success";
    } else {
        var msgClasses = "text-danger";
    }
    $("#msgSubmit").removeClass().addClass(msgClasses).text(msg);
    window.scrollTo(0, $("#msgSubmit").offset().top - 100);
}